import type { CityStep } from "./cityOrderReview";

interface Props {
  step: CityStep;
  firstStep: CityStep;
  /** Why the drawer may not go on yet, or null. */
  hold: string | null;
  saving: boolean;
  canSaveLater: boolean;
  /** A refusal from saving, shown here where the buttons are. */
  saveError: string;
  /** Offer to read the PO again, after a refusal that asks for it. */
  onReread: (() => void) | null;
  onBack: () => void;
  onContinue: () => void;
  onSaveLater: () => void;
  onConfirm: () => void;
}

/** Back, save for later, and Continue -- which on the last step becomes
 * Confirm. The two are distinct buttons, never one reused in place: a double
 * click on Continue must not land on Confirm. */
export default function Footer(props: Props) {
  const { step, saving, hold } = props;
  return (
    <div className="qr-drawer-foot">
      {step > props.firstStep ? (
        <button type="button" className="btn" onClick={props.onBack} disabled={saving}>
          Back
        </button>
      ) : null}
      {props.canSaveLater ? (
        <button type="button" className="btn" onClick={props.onSaveLater} disabled={saving}>
          Save and come back later
        </button>
      ) : null}
      {props.saveError === "" ? (
        <span className="qr-hint">{hold ?? ""}</span>
      ) : (
        <span className="qr-hint notice bad" role="alert">
          {props.saveError}
          {props.onReread !== null ? (
            <>
              {" "}
              <button type="button" className="go-link" onClick={props.onReread}>
                Read it again
              </button>
            </>
          ) : null}
        </span>
      )}
      {step < 4 ? (
        <button key="continue" type="button" className="btn btn-primary" disabled={hold !== null || saving} onClick={props.onContinue}>
          Continue
        </button>
      ) : (
        <button key="confirm" type="button" className="btn btn-primary" disabled={saving} onClick={props.onConfirm}>
          {saving ? "Saving…" : "Confirm"}
        </button>
      )}
    </div>
  );
}
